import axios from 'axios';
import {
  GetUserVerificationIdParams,
  GetUserVerificationIdResponse,
} from './aiPriseSvc.types';

const getUserVerificationId = async ({
  userToken,
  userData,
  userId,
}: GetUserVerificationIdParams): Promise<GetUserVerificationIdResponse> =>
  axios.post(
    `${
      import.meta.env.VITE_BACKEND_BASE_URL
    }/ai-prise/get-user-verification-url/`,
    {
      user_data: userData,
      user_id: userId,
    },
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );

export default {
  getUserVerificationId,
};
